import React from "react"

// @ts-ignore
import Search from "../../../../../../core/gd-components/popover-menu/search/search"

type Props = {
    className?      : string

    placeholder?    : string
    searchString?   : string

    searchable      : boolean

    onSearchChange  : func
    onHidePopover   : func
}

export default class FieldMultiselect_PopoverSearch extends React.PureComponent<Props> {

    render() {
        if (this.props.searchable) {
            return <Search className        = {Classes("popover-search", this.props.className)}
                           placeholder      = {this.props.placeholder}
                           searchString     = {this.props.searchString}
                           onSearch         = {this.props.onSearchChange}
                           onEscapePressed  = {this.props.onHidePopover}/>
        } else {
            // still need to autofocus so keyboard work
            return <span className={Classes("hidden-search-input", this.props.className)} tabIndex={0}/>
        }
    }
}